// extracted by mini-css-extract-plugin
export default {"container":"IN-z","leftColumn":"JN-z","rightColumn":"KN-z","item":"LN-z"};